export default __webpack_public_path__ + "static/media/eym_es.786c7bdf.svg";